// extracted by mini-css-extract-plugin
export var filterIncDec = "_9g-0";
export var leftBorder = "_9g-1";
export var rightBorder = "_9g-2";
export var stringInput = "_9g-3";